import { ClickoutUrl } from '@/helpers/clickout-helper';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { useExperiment } from '@/libraries/experiment';
import { getExperimentAffiliateTag } from '@/libraries/experiment/experiment-affiliation';
import { storeToRefs } from 'pinia';

export function useSofterFreeTrialListBBExp() {
	const { activeVariantWithControlGroup: variant, experimentInfo } = useExperiment('EXP_SOFTER_FREE_TRIAL_LIST_BB');

	const { country } = storeToRefs(useLanguageStore());

	function setSofterFreeTrialListBBTags(url: ClickoutUrl, shortName?: string) {
		if (!variant.value || !shortName) return url;

		if (!['atp', 'amp', 'prv', 'hlu'].includes(shortName)) return url;

		const affiliationShortId = experimentInfo.value.affiliationShortId as string;

		const tag = getExperimentAffiliateTag({
			affiliationShortId,
			variant: variant.value,
			country: country.value,
			placement: 'ft',
			providerShortName: shortName,
		});
		return url.set('uct_ctag', tag);
	}

	return {
		setSofterFreeTrialListBBTags,
	};
}
